import { CSSProperties, FunctionComponent } from 'react';
import React from 'react';
import { Alert } from 'react-bootstrap';

const AlertMessage: FunctionComponent<{ variant?: string; message: string; style?: CSSProperties }> = ({ variant, message, style }) => {
  return (
    <Alert variant={variant || 'danger'} style={{ margin: 0, padding: '5px 15px', ...style }}>
      {message}
    </Alert>
  );
};
export default AlertMessage;
